import { CancelToken } from "axios";
import { ApiAuth, ApiCall } from "./api";
import { TPremiseResponse } from "./interface/IDefaults";
import {
  IBulkAllResult,
  IChangeFolderRequest,
  IDataUpdateNotification,
  INotificationCountsSummary,
  INotificationList,
  INotificationListData,
  IQueryListNotifications,
} from "./interface/notifications.interface";

/** Limite inclui as consultas de reconciliação após ações em massa. */
export const NOTIFICATION_TIMEOUT_MS = 30000;

export const listNotifications = async (
  guid_collaborator: string,
  filters: IQueryListNotifications,
  cancelToken?: CancelToken
): Promise<TPremiseResponse<INotificationList>> => {
  const url = `/notification/list/${guid_collaborator}`;
  return await new ApiCall(url, { ...ApiAuth(cancelToken), timeout: NOTIFICATION_TIMEOUT_MS }).post<
    INotificationList,
    IQueryListNotifications
  >(filters);
};

export const getNotifications = async (
  guid_collaborator: string,
  cancelToken?: CancelToken
): Promise<TPremiseResponse<INotificationListData>> => {
  const url = `/notification/get/${guid_collaborator}`;
  return await new ApiCall(url, {
    ...ApiAuth(cancelToken),
    timeout: NOTIFICATION_TIMEOUT_MS,
  }).get<INotificationListData>();
};

/** A Central não consulta por GUID isolado: o contexto ativo faz parte da leitura. */
export const getNotificationForCollaborator = async (
  guid_collaborator: string,
  guid_notification: string
): Promise<TPremiseResponse<INotificationListData>> => {
  const url = `/notification/get-for-collaborator/${guid_collaborator}/${guid_notification}`;
  return await new ApiCall(url, { ...ApiAuth(), timeout: NOTIFICATION_TIMEOUT_MS }).get<INotificationListData>();
};

export const getMessageCountsSummary = async (
  guid_collaborator: string,
  filters: IQueryListNotifications,
  cancelToken?: CancelToken
): Promise<TPremiseResponse<INotificationCountsSummary>> => {
  const url = `/notification/notifications-summary/${guid_collaborator}`;
  return await new ApiCall(url, { ...ApiAuth(cancelToken), timeout: NOTIFICATION_TIMEOUT_MS }).post<
    INotificationCountsSummary,
    IQueryListNotifications
  >(filters);
};

export const countUnread = async (guid_collaborator: string): Promise<TPremiseResponse<number>> => {
  const url = `/notification/count-unread/${guid_collaborator}`;
  return await new ApiCall(url, { ...ApiAuth(), timeout: NOTIFICATION_TIMEOUT_MS }).get<number>();
};

export const updateNotification = async (
  guid_notification: string,
  data: IDataUpdateNotification
): Promise<TPremiseResponse<boolean>> => {
  const url = `/notification/update/${guid_notification}`;
  return await new ApiCall(url, { ...ApiAuth(), timeout: NOTIFICATION_TIMEOUT_MS }).post<any, IDataUpdateNotification>(
    data
  );
};

export const changeFolder = async (
  guid_client: string,
  data: IChangeFolderRequest
): Promise<TPremiseResponse<boolean>> => {
  const url = `/notification/change-folder/${guid_client}`;
  return await new ApiCall(url, { ...ApiAuth(), timeout: NOTIFICATION_TIMEOUT_MS }).post<any, IChangeFolderRequest>(
    data
  );
};

export const getNotificationSubjectOptions = async (
  guid_collaborator: string,
  search: string
): Promise<TPremiseResponse<any>> => {
  const url = `/notification/get-subjects/${guid_collaborator}`;
  return await new ApiCall(url, { ...ApiAuth(), timeout: NOTIFICATION_TIMEOUT_MS }).post<any, any>({ search });
};

export const bulkMarkAsRead = async (
  guid_collaborator: string,
  read: boolean,
  data: Array<string>
): Promise<TPremiseResponse<boolean>> => {
  const url = `/notification/bulk-mark-as-read/${guid_collaborator}/${read ? "1" : "0"}`;
  return await new ApiCall(url, { ...ApiAuth(), timeout: NOTIFICATION_TIMEOUT_MS }).post<any, any>(data);
};

export const bulkMarkAsImportant = async (
  guid_collaborator: string,
  important: boolean,
  data: Array<string>
): Promise<TPremiseResponse<boolean>> => {
  const url = `/notification/bulk-mark-as-important/${guid_collaborator}/${important ? "1" : "0"}`;
  return await new ApiCall(url, { ...ApiAuth(), timeout: NOTIFICATION_TIMEOUT_MS }).post<any, any>(data);
};
/** GEN-4101 — marca como lidas TODAS as não lidas que batem com os filtros (no servidor, sem teto de 200). */
export const markAllNotificationsAsRead = async (
  guid_collaborator: string,
  filters: Partial<IQueryListNotifications>
): Promise<TPremiseResponse<IBulkAllResult>> => {
  const url = `/notification/mark-all-read/${guid_collaborator}`;
  return await new ApiCall(url, { ...ApiAuth(), timeout: NOTIFICATION_TIMEOUT_MS }).post<
    IBulkAllResult,
    Partial<IQueryListNotifications>
  >(filters);
};

/** GEN-4101 — arquiva tudo da Entrada que bate com os filtros. */
export const archiveAllNotifications = async (
  guid_collaborator: string,
  filters: Partial<IQueryListNotifications>
): Promise<TPremiseResponse<IBulkAllResult>> => {
  const url = `/notification/archive-all/${guid_collaborator}`;
  return await new ApiCall(url, { ...ApiAuth(), timeout: NOTIFICATION_TIMEOUT_MS }).post<
    IBulkAllResult,
    Partial<IQueryListNotifications>
  >(filters);
};
